export interface KadieMessage {
  id: string;
  role: string;
  content: string;
  createdAt: string;
  sourceNames?: string[] | null;
}

export interface KadieConversation {
  id: string;
  messages: KadieMessage[];
}

const APPLICANT_ROLES = new Set(['APPLICANT', 'USER']);

export function isApplicantRole(role: string): boolean {
  return APPLICANT_ROLES.has(role.toUpperCase());
}

export interface LauncherPosition {
  right: number;
  bottom: number;
}

export interface KadieChatState {
  conversationId: string;
  messages: KadieMessage[];
  draft: string;
}
